import { Inject, Injectable, NgZone } from '@angular/core';
import { ApmBase } from '@elastic/apm-rum';
import { firstValueFrom } from 'rxjs';
import { OrderformFascade } from '../fascades/orderform.fascade';
import { generateUUID } from '@ds24/ds-generic-api';
import { APM } from '@elastic/apm-rum-angular';

const MONITORING_ERROR_INCLUDE_LIST = ['unzer', 'digistore24', 'svencart', 'stripe'];
const MONITORING_ERROR_EXCLUDE_LIST = ['https://', 'safari-extension', 'chrome-extension'];

@Injectable({
  providedIn: 'root',
})
/**
 * @deprecated: use new TrackingService
 */
export class MonitoringService {
  constructor(@Inject(APM) private _apm: ApmBase, private _fascade: OrderformFascade, private _ngZone: NgZone) {}

  async initialize() {
    // @ts-ignore
    const ELASTIC_CONFIG = window.ELASTIC_CONFIG;

    if (
      ELASTIC_CONFIG &&
      ELASTIC_CONFIG.elasticApmServiceName !== '' &&
      ELASTIC_CONFIG.elasticApmServiceName.slice(0, 1) !== '$'
    ) {
      this._ngZone.runOutsideAngular(() => {
        this._apm.init({
          serviceName: ELASTIC_CONFIG.elasticApmServiceName,
          serverUrl: ELASTIC_CONFIG.elasticApmServerUrl,
          serviceVersion: ELASTIC_CONFIG.elasticApmServiceVersion,
          environment: ELASTIC_CONFIG.elasticApmEnvironment,
          disableInstrumentations: ['click'],
          flushInterval: 200,
        });
      });
      this._apm.addLabels({
        'user_agent.device.width': window.innerWidth,
      });
      if (window.location.pathname.startsWith('/product')) {
        this._apm.addLabels({ orderform: 'PGB' });
        this._apm.addLabels({
          hasParentFrame: window.parent !== window,
        });
      } else {
        this._apm.addLabels({ renew: 'PGB' });
      }

      this._apm.addFilter(function (payload) {
        if (payload.errors) {
          payload.errors = payload.errors.filter(function (error) {
            if (MONITORING_ERROR_INCLUDE_LIST.filter((subject) => error.culprit.indexOf(subject) > -1).length > 0) {
              return true;
            }
            if (MONITORING_ERROR_EXCLUDE_LIST.filter((subject) => error.culprit.indexOf(subject) > -1).length > 0) {
              return false;
            }
            return true;
          });
        }
        return payload;
      });

      const affiliate = await firstValueFrom(this._fascade.affiliateName$);
      const vendor = await firstValueFrom(this._fascade.merchantName$);
      const orderformCustomerToken = generateUUID();
      this.addLabels({ affiliate, vendor, orderformCustomerToken });

      const experiments = await this._fascade.viewedExperiments;
      experiments?.forEach((experiment) => {
        this.addLabels({
          [`experiment_${experiment.key}_enabled`]: true,
          [`experiment_${experiment.key}_variation`]: experiment.variation,
        });
      });
    }
  }

  public addLabels(labels: Labels) {
    this._apm.addLabels(labels);
  }

  public isActive() {
    return this._apm.isActive();
  }

  public captureError(error: Error) {
    this._apm.captureError(error);
  }
}
